import { Link } from "react-router-dom";
import { Card, Button, Row, Col } from "react-bootstrap";
import imgInicial from "../../assets/images/nivelinicial.jpg";
import imgPrimario from "../../assets/images/primaria.jpg";
import imgSecundario from "../../assets/images/nivelsecundario.png";

function HomePage() {
  return (
    <section className="home-levels-section">
      <div className="container">
        <div className="home-section-heading">
          <span>Proyecto educativo</span>
          <h2>Niveles de formación</h2>
        </div>

        <Row xs={1} md={3} className="g-4">
          <Col>
            <Card className="home-level-card h-100">
              <Card.Img variant="top" src={imgInicial} alt="Nivel Inicial" className="home-level-image" />
              <Card.Body className="d-flex flex-column">
                <Card.Title className="fw-bold fs-4 text-center">Inicial</Card.Title>
                <Card.Text className="flex-grow-1 text-center">
                  Acompañamos los primeros pasos educativos con juego, contención y propuestas que favorecen el
                  desarrollo integral.
                </Card.Text>
                <div className="text-center mt-3">
                  <Link to="/homeinicial">
                    <Button className="home-level-button">Leer más</Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col>
            <Card className="home-level-card h-100">
              <Card.Img variant="top" src={imgPrimario} alt="Nivel Primario" className="home-level-image" />
              <Card.Body className="d-flex flex-column">
                <Card.Title className="fw-bold fs-4 text-center">Primario</Card.Title>
                <Card.Text className="flex-grow-1 text-center">
                  Brindamos una educación sólida y cercana, combinando conocimientos, habilidades socioemocionales y
                  pensamiento crítico.
                </Card.Text>
                <div className="text-center mt-3">
                  <Link to="/nivelprimario">
                    <Button className="home-level-button">Leer más</Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col>
            <Card className="home-level-card h-100">
              <Card.Img variant="top" src={imgSecundario} alt="Nivel Secundario" className="home-level-image" />
              <Card.Body className="d-flex flex-column">
                <Card.Title className="fw-bold fs-4 text-center">Secundario</Card.Title>
                <Card.Text className="flex-grow-1 text-center">
                  Preparamos a los jóvenes para nuevos desafíos, fortaleciendo autonomía, responsabilidad y
                  participación activa.
                </Card.Text>
                <div className="text-center mt-3">
                  <Link to="/nivelsecundario">
                    <Button className="home-level-button">Leer más</Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default HomePage;
